(function(){
  const SOURCE_SEL='.toolbar.small--hide';
  const TARGET_SEL='.announcement-bar__selectors';
  const CONTENT_SEL='.toolbar__content';
  const src0=document.querySelector(SOURCE_SEL);
  if(src0){
    src0.style.opacity='0';
    src0.style.pointerEvents='none';
    src0.style.transition='opacity .25s ease';
    const inner0=src0.querySelector(CONTENT_SEL);
    if(inner0)inner0.style.opacity='0';
  }
  function moveToolbar(){
    const src=document.querySelector(SOURCE_SEL);
    const tgt=document.querySelector(TARGET_SEL);
    if(src&&tgt&&!tgt.contains(src)){
      tgt.appendChild(src);
      src.style.setProperty('display','block','important');
      src.style.background='#000';
      src.style.color='#fff';
      src.style.pointerEvents='';
      const inner=src.querySelector(CONTENT_SEL);
      if(inner)inner.style.opacity='1';
      requestAnimationFrame(()=>{src.style.opacity='1';});
    }
  }
  document.addEventListener('DOMContentLoaded',moveToolbar);
  document.addEventListener('shopify:section:load',moveToolbar);
})();



document.addEventListener('DOMContentLoaded', () => {

  let AUTO_MS = 5500;            

  document.querySelectorAll('.announcement-bar__content').forEach(bar => {

    let slides = bar.querySelectorAll('.ann-slide');
    if (slides.length < 2) return;

    let idx  = 0;
    let show = i => {
      slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      idx = i;
    };
    show(0);

    let prev = bar.querySelector('.ann-arrow--left');
    let next = bar.querySelector('.ann-arrow--right');
    if (prev) prev.addEventListener('click', () => show((idx - 1 + slides.length) % slides.length));
    if (next) next.addEventListener('click', () => show((idx + 1) % slides.length));

    let timer = setInterval(() => show((idx + 1) % slides.length), AUTO_MS);

    bar.addEventListener('mouseenter', () => clearInterval(timer));
    bar.addEventListener('mouseleave', () => {
      timer = setInterval(() => show((idx + 1) % slides.length), AUTO_MS);
    });

    window.addEventListener('resize', () => {
      clearInterval(timer);
      timer = setInterval(() => show((idx + 1) % slides.length), AUTO_MS);
    });
  });

});